export default __webpack_public_path__ + "static/media/default-cat.32775396.png";